export enum TypeModel {
    CHOICE_PROMPT_MESSAGE = 'choice_prompt',
    PARTICIPANT_MESSAGE = 'participant',
    PLAIN_TEXT_MESSAGE = 'plain_text',
    ATTACH_CHANNEL = 'attach_channel',
    SERVICE_ATTACH = 'service_attach',
    SERVICE_DATA = 'service_data',
    START_CONVERSATION = 'start_conversation',
    CTA_MESSAGE = 'cta'
}
